import React from "react";

type Props = {};

const RetirementBenefitsNonNCHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <p className="leading-para text-greyDark text-start">
        The USA, UK, and Canada are classified as "notified countries" for Section 89A of the Income
        Tax Act, while all other countries are classified as "non-notified" countries.
      </p>
    </>
  );
};

export default RetirementBenefitsNonNCHint;
